document.addEventListener("DOMContentLoaded", function () {
  const vatToggleState = localStorage.getItem("vatToggleState");
  if (vatToggleState === "inc") {
    document.body.classList.add("inc-vat");
  } else {
    document.body.classList.remove("exc-vat");
  }
  const vatButtons = document.querySelectorAll("[data-vat-change-button]");

  function updatePrices(price) {
    let originalPrice = price.getAttribute("data-original-price");
    if (originalPrice) {
      if (vatToggleState === "exc") {
        if (!price.classList.contains("price--hide-vat")) {
          price.innerHTML = `£${Number(
            originalPrice.replace(/,/g, "")
          ).toLocaleString("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} <span class="price-vat-status">ex VAT</span>`;
        } else {
          price.innerHTML = `£${Number(
            originalPrice.replace(/,/g, "")
          ).toLocaleString("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
      } else {
        let priceWithVAT = Number(originalPrice.replace(/,/g, "")) * 1.2;
        let formattedPrice = priceWithVAT.toLocaleString("en-GB", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        if (!price.classList.contains("price--hide-vat")) {
          price.innerHTML = `£${formattedPrice} <span class="price-vat-status">inc VAT</span>`;
        } else {
          price.innerHTML = `£${formattedPrice}`;
        }
      }
    }
  }

  const allPrices = document.querySelectorAll(".price-item");
  allPrices.forEach((price) => {
    updatePrices(price);
  });

  vatButtons.forEach((vatButton) => {
    if (vatToggleState === "inc") {
      vatButton.checked = false;
    } else {
      vatButton.checked = true;
    }

    vatButton.addEventListener("change", function () {
      const allPrices = document.querySelectorAll(".price-item");
      allPrices.forEach((price) => {
        let originalPrice = price.getAttribute("data-original-price");
        if (originalPrice) {
          if (document.body.classList.contains("inc-vat")) {
            if (!price.classList.contains("price--hide-vat")) {
              price.innerHTML = `£${originalPrice} <span class="price-vat-status">ex VAT</span>`;
            } else {
              price.innerHTML = `£${originalPrice}`;
            }

            localStorage.setItem("vatToggleState", "exc");
          } else {
            let noCommaPrice = originalPrice.replace(/,/g, "");
            let priceWithoutVAT = (noCommaPrice * 1.2).toFixed(2);
            if (!price.classList.contains("price--hide-vat")) {
              price.innerHTML = `£${priceWithoutVAT} <span class="price-vat-status">inc VAT</span>`;
            } else {
              price.innerHTML = `£${priceWithoutVAT}`;
            }
            localStorage.setItem("vatToggleState", "inc");
          }
        }
      });
      document.body.classList.toggle("inc-vat");
    });
  });
});
